module.exports = __webpack_public_path__ + "img/20190725162134QQ截图20190725005911.37b3d79b.png";